import { apiGet } from '../utils/apiClient';

export default class BasicConfigIntegration {
    getBusiness() {
        return apiGet(`${process.env.REACT_APP_JSON_URL}/businessLines.json`)
            .then((d) => d.data);
    }

    getLanguage() {
        return apiGet(`${process.env.REACT_APP_JSON_URL}/language.json`)
            .then((d) => d.data);
    }

    getFeatures() {
        return apiGet(`${process.env.REACT_APP_JSON_URL}/features.json`);
    }
}
